export default __webpack_public_path__ + "static/media/Flag_of_Venezuela.513cf094.svg";